import React from "react"
import PropTypes from "prop-types"
import "./DropdownField.css"
import { ArrowDownIcon } from "../../Icons"

class DropdownFieldOption extends React.Component {
  handleClick = () => {
    const { onClick, value } = this.props
    onClick(value)
  }

  render() {
    const { label } = this.props
    return <li onClick={this.handleClick}>{label}</li>
  }
}

DropdownFieldOption.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}

class DropdownField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      shown: false
    }
    this.ref = React.createRef()
  }

  handleClickOutside = e => {
    if (
      this.ref.current !== e.path[0] &&
      !this.ref.current.contains(e.path[0])
    ) {
      this.setState(state => ({
        ...state,
        shown: false
      }))
    }
  }

  handleClick = () => {
    this.setState({
      shown: !this.props.disabled && !this.state.shown
    })
  }

  selectOption = option => {
    const { name } = this.props.field
    const { setFieldValue, setFieldTouched } = this.props.form
    setFieldValue(name, option)
    setFieldTouched(name)
    this.setState({ shown: false })
  }

  getOptionLabel = () => {
    const selectedOption = this.props.options.find(
      option => option.value === this.props.value
    )
    const label =
      (selectedOption && selectedOption.label) || this.props.defaultValue.label
    return label
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside)
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside)
  }

  render() {
    const {
      field,
      form: { touched, errors }
    } = this.props

    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (touched[field.name] && field.value && !errors[field.name]) {
      status = "is-fixed"
    }

    const winHeight = window.innerHeight
    const { bottom } =
      (this.ref.current && this.ref.current.getBoundingClientRect()) || 0

    return (
      <div
        className={`DropdownField ${
          this.state.shown ? "shown" : ""
        } ${status} ${this.props.disabled ? "disabled" : ""} 
        ${winHeight - bottom < 260 ? "up" : "down"}`}
        ref={this.ref}
      >
        <span onClick={this.handleClick}>
          {this.getOptionLabel()} <ArrowDownIcon />
        </span>
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
        <div className="DropdownField-options">
          <ul>
            {this.props.options.map((option, i) => (
              <DropdownFieldOption
                key={i}
                onClick={this.selectOption}
                value={option.value}
                label={option.label}
              />
            ))}
          </ul>
        </div>
      </div>
    )
  }
}

DropdownField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  defaultValue: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })
}

export default DropdownField
